export const RETRIEVE_AGENDAS = 'agendas/retrieve';
export default RETRIEVE_AGENDAS;
